import '@/assets/styles/global/fonts.scss'
import '@/assets/styles/main.scss'
import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import 'element-plus/theme-chalk/dark/css-vars.css'
import router from './router'
import App from './App.vue'

const app = createApp(App)
    .use(router)
    .use(ElementPlus)

app.mount('#app')
